export default {
  OK: 0,
  RESEND_BLOCKED: 1,
  OPTED_OUT: 2,
  TOO_MANY_REQUESTS: 3,
  EMAIL_SENDING_ERROR: 4,
  THROTTLING_REACHED_ERROR: 5
};